var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"radius4",on:{"click":_vm.switchLanguage}},[_c('font-awesome-icon',{attrs:{"icon":"fa-solid fa-globe"}}),_vm._v(" "+_vm._s(_vm.displayLanguage)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }